import { render, staticRenderFns } from "./TcPolicy.vue?vue&type=template&id=67633d66&"
import script from "./TcPolicy.vue?vue&type=script&lang=js&"
export * from "./TcPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67633d66')) {
      api.createRecord('67633d66', component.options)
    } else {
      api.reload('67633d66', component.options)
    }
    module.hot.accept("./TcPolicy.vue?vue&type=template&id=67633d66&", function () {
      api.rerender('67633d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/TcPolicy.vue"
export default component.exports